module.exports = "/assets/51c3baa185b03c0bea185ac526c28629.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/GJ.png
// module id = 1407
// module chunks = 0